import React from 'react';
import { ToggleButtonGroup, ToggleButton } from 'react-bootstrap';
import _ from 'lodash';
import styles from './toggleButtons.module.scss';
import classnames from 'classnames/bind';

type ToggleButtonsProps = {
  type?: any;
  value: string | number;
  name: string;
  options: SelectOptions[];
  disabledValues?: (string | number)[];
  onChange: (value: string | number) => void;
  className?: string;
  /**
   * 自訂單一選項的內容，例如在文字後面掛一個數量 badge。
   * 不給就直接顯示 `option.label`（既有呼叫端不受影響）。
   */
  renderLabel?: (option: SelectOptions) => React.ReactNode;
};

const cx = classnames.bind(styles);

const ToggleButtons: React.FunctionComponent<ToggleButtonsProps> = ({
  type = 'radio',
  value,
  name,
  options = [],
  disabledValues = [],
  onChange: handleChange = _.noop,
  className: parentClassName,
  renderLabel
}) => {
  const className = cx(parentClassName, 'toggleButtons');
  return (
    <ToggleButtonGroup
      type={type}
      value={value}
      onChange={handleChange}
      name={name}
      className={className}
    >
      {options &&
        options.map((option: SelectOptions) => (
          <ToggleButton
            variant='secondary'
            key={option.value}
            value={option.value}
            disabled={disabledValues.includes(option.value)}
          >
            {renderLabel ? renderLabel(option) : option.label}
          </ToggleButton>
        ))}
    </ToggleButtonGroup>
  );
};

export default ToggleButtons;
